import { useReceiptStore } from "@elixir/stores";
import { ReceiptRawFunctionsPayload } from "@elixir/stores/src/receipt-store/types";
import { Appointment, SUBJECT_KEYS, TReceipt } from "@elixir/types";
import { EKA_EVENT, EVENT_TYPES } from "./bridges";
import { isAccessAvailable, showAccessDeniedError } from "./bridges/methods";

export function createNewReceipt({
  appointment,
  onReceiptSuccess,
}: {
  appointment?: Appointment | null;
  onReceiptSuccess?: () => void;
}) {
  const isCreateReceiptAllowed = isAccessAvailable(
    SUBJECT_KEYS.CAN_CREATE_RECEIPT_WITH_APT
  );
  if (isCreateReceiptAllowed) {
    if (onReceiptSuccess) {
      useReceiptStore.getState().setOnReceiptSuccess(onReceiptSuccess);
    }
    useReceiptStore.getState().openNewReceiptPopup({
      appointment: appointment ? appointment : undefined,
    });
  } else {
    showAccessDeniedError();
  }
}

export function editReceipt({
  appointment,
  receiptId,
  onReceiptSuccess,
}: {
  appointment?: Appointment | null;
  receiptId?: number;
  onReceiptSuccess?: () => void;
}) {
  const isReceiptEditAllowed = isAccessAvailable(SUBJECT_KEYS.RECEIPT_EDIT);
  if (isReceiptEditAllowed) {
    if (onReceiptSuccess) {
      useReceiptStore.getState().setOnReceiptSuccess(onReceiptSuccess);
    }
    useReceiptStore.getState().editReceipt({
      appointment: appointment ? appointment : undefined,
      receiptId,
    });
  } else {
    showAccessDeniedError();
  }
}

export function sendPaymentLink({ appointment }: { appointment: Appointment }) {
  useReceiptStore.getState().sendPaymentLink({ appointment });
}

export function viewAllReceipt({ appointment }: { appointment: Appointment }) {
  useReceiptStore.getState().viewAllReceipt({ appointment });
}

/**
 *
 * Never use this function directly from queue. To be used only when appointment context is already given to the receipts store. For ex: When already in view all receipts popup. If you want to view a specific receipt use this.
 */
export function viewReceipt({
  receipt,
  appointment,
  onReceiptSuccess,
}: {
  receipt: TReceipt;
  /**
   * Appointment needs to be provided when view receipt is done based on just receipt entity. Appointment needs to be provided so that New receipt button can be handled well.
   */
  appointment?: Appointment;
  onReceiptSuccess?: () => void;
}) {
  if (onReceiptSuccess) {
    useReceiptStore.getState().setOnReceiptSuccess(onReceiptSuccess);
  }
  useReceiptStore.getState().viewReceipt({ receipt, appointment });
}

export function settleDues({ appointment }: { appointment: Appointment }) {
  useReceiptStore.getState().settleDues({ appointment });
}

export function createReceiptRaw(
  data: Parameters<ReceiptRawFunctionsPayload>[0]
) {
  useReceiptStore.getState().createReceiptRaw(data);
}

export function settleDuesRaw(data: Parameters<ReceiptRawFunctionsPayload>[0]) {
  useReceiptStore.getState().settleDuesRaw(data);
}

export function closeReceiptPopupEvent() {
  dispatchEvent(
    new CustomEvent(EKA_EVENT, {
      detail: {
        type: EVENT_TYPES.CLOSE_BILLING_POPUP,
      },
    })
  );
}
